import { CustomForm } from '../../../types/CustomForm'
import { stripRelationshipItems } from '../../../utils/mapFormAnswers'

/**
 * The RegistrationContext `selectedPlayer` is `any`; a real, already-existing
 * player has an id other than the `'new'` sentinel used for a brand-new player.
 */
interface SelectedPlayerLike {
  id?: string | null
}

/** Sentinel id the registration flow assigns to a not-yet-created player. */
const NEW_PLAYER_ID = 'new'

/**
 * Returns true when the currently selected player is an existing player (i.e. a
 * real id, not the `'new'` sentinel and not absent). The relationship field is
 * only relevant when creating a new player, so this gates whether it is shown
 * and submitted.
 */
export const isExistingSelectedPlayer = (
  selectedPlayer: SelectedPlayerLike | null | undefined
): boolean =>
  Boolean(selectedPlayer?.id) && selectedPlayer?.id !== NEW_PLAYER_ID

/**
 * Returns the form to render and submit for the given selected player. For an
 * existing player the relationship field is stripped (it is only relevant when
 * creating a new player); otherwise the form passes through unchanged. Falsy
 * forms pass through as-is.
 */
export const formForSelectedPlayer = (
  form: CustomForm | null,
  selectedPlayer: SelectedPlayerLike | null | undefined
): CustomForm | null =>
  form && isExistingSelectedPlayer(selectedPlayer)
    ? stripRelationshipItems(form)
    : form
